import { Alert, CollapseProps, Typography } from 'antd'

const { Title } = Typography

export const helpItemsForm: CollapseProps['items'] = [
    {
        key: '1',
        label: <b>Обзор</b>,
        children: (
            <>
                <p>
                    Карточка клиента объединяет реквизиты компании, список кураторов и контакты для
                    отгрузок. Эти данные используются при создании расчётов и при оформлении
                    доставки.
                </p>
                <p>
                    Форма одинакова при создании и редактировании клиента. После сохранения вы
                    возвращаетесь в список клиентов.
                </p>
            </>
        ),
    },
    {
        key: '2',
        label: <b>Основные поля</b>,
        children: (
            <>
                <ul>
                    <li>
                        <b>Имя клиента</b> — обязательное поле.
                    </li>
                    <li>
                        <b>Юридический адрес</b> — адрес с подсказками DaData. Нужно выбрать
                        значение из списка. Если адреса нет — отметьте «Нет адреса».
                    </li>
                    <li>
                        <b>Отсрочка (в днях)</b> — количество дней отсрочки платежа.
                    </li>
                    <li>
                        <b>Источник</b> — откуда пришёл клиент: «Сайт», «Выставка» или «Менеджер».
                        При выборе «Выставка» заполните поле «Наименование выставки».
                    </li>
                    <li>
                        <b>Комментарий</b> — произвольный текст о клиенте.
                    </li>
                </ul>
            </>
        ),
    },
    {
        key: '3',
        label: <b>Кураторы</b>,
        children: (
            <>
                <p>
                    Кураторы — менеджеры и помощники, которые работают с этим клиентом. Именно эти
                    клиенты будут показываться кураторам при создании новых расчётов.
                </p>
                <Title level={3}>Правила</Title>
                <ul>
                    <li>Минимум один куратор обязателен.</li>
                    <li>
                        При создании клиента по умолчанию указывается текущий пользователь с
                        процентом 3.5%.
                    </li>
                    <li>
                        В качестве куратора можно выбрать пользователя с должностью «Менеджер» или
                        «Помощник менеджера».
                    </li>
                    <li>
                        Обычно у клиента один или два куратора — менеджер и его помощник.
                    </li>
                </ul>
                <Title level={3}>Процент</Title>
                <p>
                    У каждого куратора указывается процент от 0 до 3.5 (шаг 0.5). Суммарный процент
                    по клиенту не должен превышать 3.5 — он используется для начисления баллов.
                    Кураторы делят этот процент между собой.
                </p>
                <p>Пример: менеджер — 3%, помощник — 0.5%.</p>
            </>
        ),
    },
    {
        key: '4',
        label: <b>Контакты для отгрузок</b>,
        children: (
            <>
                <p>
                    Контакты — адреса и получатели для доставки готовой продукции. Минимум один
                    контакт обязателен.
                </p>
                <Title level={3}>Поля контакта</Title>
                <ul>
                    <li>
                        <b>Адрес получателя</b> — выбрать из подсказок DaData или отметить
                        «Нет адреса». Широта и долгота заполняются автоматически и не
                        редактируются вручную.
                    </li>
                    <li>
                        <b>Имя получателя</b> — обязательное поле.
                    </li>
                    <li>
                        <b>Телефон получателя</b> — обязательное поле.
                    </li>
                    <li>
                        <b>Часы работы</b> — интервал времени приёма.
                    </li>
                    <li>
                        <b>Комментарий к контакту</b> — дополнительная информация для доставки.
                    </li>
                    <li>
                        <b>Основной контакт</b> — переключатель. Хотя бы один контакт должен быть
                        отмечен как основной.
                    </li>
                </ul>
                <p>
                    Можно добавить несколько контактов кнопкой «Добавить контакт». Удаление —
                    иконкой минус в блоке контакта.
                </p>
            </>
        ),
    },
    {
        key: '5',
        label: <b>Статус и workflow</b>,
        children: (
            <>
                <p>
                    Поле «Статус подтверждения» доступно только логисту. Возможные значения:
                </p>
                <ul>
                    <li>
                        <b>Черновик</b> — клиент создан или изменён, данные ещё не проверены.
                    </li>
                    <li>
                        <b>Подтвержден</b> — логист проверил адрес и данные клиента.
                    </li>
                </ul>
                <p>Типичный сценарий:</p>
                <ol>
                    <li>Менеджер создаёт клиента и заполняет данные — статус «Черновик».</li>
                    <li>
                        Менеджер передаёт данные логистам для проверки (особенно адрес и контакты).
                    </li>
                    <li>Логист проверяет данные и переводит клиента в статус «Подтвержден».</li>
                </ol>
                <Alert
                    showIcon
                    style={{ marginTop: 8 }}
                    message='Для запуска отгрузки по новому клиенту нужно, чтобы логисты проверили адрес и подтвердили данные. Клиент, созданный при оформлении расчёта, также сохраняется как черновик.'
                    type='warning'
                />
            </>
        ),
    },
    {
        key: '6',
        label: <b>Кто может редактировать</b>,
        children: (
            <>
                <Title level={3}>Менеджер и Помощник менеджера</Title>
                <ul>
                    <li>Могут создавать новых клиентов.</li>
                    <li>
                        Могут редактировать карточку, пока статус «Черновик». После подтверждения
                        форма становится только для просмотра.
                    </li>
                    <li>Не могут менять статус подтверждения.</li>
                </ul>
                <Title level={3}>Логист</Title>
                <ul>
                    <li>Может редактировать карточку клиента в любой момент, в том числе после подтверждения.</li>
                    <li>Может менять статус подтверждения.</li>
                    <li>
                        Может подтвердить клиента из списка кнопкой «Подтвердить» или через поле
                        статуса в форме.
                    </li>
                </ul>
                <Title level={3}>Супер Админ</Title>
                <ul>
                    <li>Видит всех клиентов без ограничений.</li>
                    <li>
                        Редактирование подтверждённых клиентов и смена статуса доступны только при
                        наличии роли «Логист».
                    </li>
                </ul>
            </>
        ),
    },
]
